import { useToast } from '@fukuri-admins/ui/common/Toast/hooks';
import { getClients } from '~/api/clients';
import { ApiResponse, OptionType } from '../../../../../../src/component/PaginatedSelect/type';
import { clientToOption } from '../logics';

type UseClientOptionsReturn = {
  searchAction: (input: string, page: number) => Promise<ApiResponse>;
};

type UseClientOptionsArgs = {
  signOut: () => void;
};

/**
 * クライアント選択用のオプションを取得するカスタムフック
 * @param signOut - ログアウト処理
 * @returns searchAction - ページネーション対応の検索関数
 */
export const useClientOptions = ({ signOut }: UseClientOptionsArgs): UseClientOptionsReturn => {
  const { showToast } = useToast();

  const searchAction = async (input: string, page: number): Promise<ApiResponse> => {
    try {
      // TODO: useSWRに置き換える
      const { data, headers } = await getClients(signOut, {
        name: input,
        page: page.toString(),
      });

      // ClientType -> OptionType に変換
      const options: OptionType[] = data.clients.map(clientToOption);

      return {
        options,
        headers: {
          'total-pages': headers['total-pages'],
        },
      };
    } catch {
      showToast({ message: 'データの取得に失敗しました。', status: 'danger' });
      return { options: [], headers: { 'total-pages': '0' } };
    }
  };

  return { searchAction };
};
